<template>
    <div class="roadmap-initiative-display">
          <div class="col-12 form-inline pl-0 pb-2">
            <div class="col-3">
              <div class="d-flex justify-content-left flex-wrap leftLabel moat-name-header">Moat</div>
            </div>
            <div class="col-9">
              <div class="d-flex justify-content-left flex-wrap labelData moat-name-header">{{ moatName }}</div>
            </div>
          </div>
          <div class="col-12 form-inline pl-0 pb-2" v-if="moatFeatures">
            <div class="col-3">
              <div class="d-flex justify-content-left flex-wrap leftLabel">Moat Description</div>
            </div>
            <div class="col-9">
              <div class="d-flex justify-content-left flex-wrap labelData">{{ moatFeatures }}</div>
            </div>
          </div>
    </div>
</template>

<script>
export default {
    name: "RoadMapInitiativeDisplay",
    components: {},
    data() {
        return {};
    },
    methods: {},
    props: {
        moatName: {
            type: String,
            default: "",
        },
        moatDescription: {
            type: Object,
            default: () => ({}),
        },
    },
    computed:{
        moatFeatures() {
        if (typeof this.moatDescription != "undefined" && this.moatDescription != null && this.moatDescription.attributes) {
            let moatAttributes = JSON.parse(this.moatDescription.attributes);
            return moatAttributes?.features || "";
        }
        return "";
        },        
    }
};
</script>
